import { LogoImg } from "../NewAccount/style";
import Logo from "./../../assets/Logo.png";
import './style.css';

export const AppInside = () => {
    return (
        <div id="app-redirect">
            <LogoImg src={Logo} width={250} />

            <div className="info-container">

                <h1 className="info-title">Aplicativo da Inside Brasil</h1>
                <p className="info-description">Agora, todo seu histórico na Inside é acessado apenas pelo nosso aplicativo. Baixe agora mesmo para ver suas pesquisas, os valores a receber e a possibilidade de ser remunerado por indicações para amigos</p>
            </div>

            <div className="button-container">
                <a target='_blank' href='https://apps.apple.com/br/app/inside-brasil/id6737057631' className='button-link'>
                    <button className='button'>
                        <LogoImg src='https://img.icons8.com/?size=100&id=95294&format=png&color=FFFFFF' alt="Apple Store ícone" className='button-icon' />
                        <b>Disponível na<br />Apple Store</b>
                    </button>
                </a>

                <a target='_blank' href='https://play.google.com/store/apps/details?id=br.com.inside.mobileApp' className='button-link'>
                    <button className='button'>
                        <LogoImg src='https://img.icons8.com/?size=100&id=22982&format=png&color=FFFFFF' alt="Google Play ícone" className='button-icon' />
                        <b> Disponível na<br /> Google Play</b>
                    </button>
                </a>
            </div>
        </div>
    )
}